import React from 'react';
import styled from 'styled-components';

import WP from 'WP';

import Media from 'css/Media';

const InputField = props => {
    const getErrorText = () => {
        switch(props.id) {
            case 'email':
                return <p>{WP.trans.invalidEmail}</p>;
            case 'phone':
                return <p>{WP.trans.invalidTel}</p>;
            default: 
                return <p>{WP.trans.invalidBlank} {props.label.toLowerCase()}</p>
        }
    }
    return(
        <StyledLabel id={props.id} className={props.className} validated={props.validated}>
            <p>{props.label}</p>
            <input 
                type={props.type} 
                name={props.id} 
                onChange={props.onChange}
                onBlur={props.onBlur}
                value={props.value}
            />
            {!props.validated && getErrorText()}
        </StyledLabel>
    )
}

export default InputField;


const StyledLabel = styled.label`
    p {
        ${Media.greaterThan('s')`
            padding: 0 0 ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM};
        `}
    }

    >p:first-of-type {
        ${props => props.theme.fonts.h6}
        color: ${props => props.theme.colors.inputText};
    }

    input {
        ~ p {
            color: ${props => props.theme.colors.danger};
            font-size: 14px;
            line-height: 16px;
            padding-top: ${props => props.theme.spacing.contentS};

            ${Media.greaterThan('s')`
                font-size: 16px;
            `}
        }
    }

    input[type="text"],
    input[type="email"],
    input[type="number"],
    input[type="tel"] {
        width: 100%;
        height: ${props => props.theme.spacing.elementS};
        border: 1px solid ${props => props.validated ? props.theme.colors.input : props.theme.colors.danger};
        box-shadow: none;
        -webkit-appearance: none;
        border-radius: 0;
        ${props => props.theme.fonts.p};
        font-size: 14px;
        padding: 0 25px;
        background-color: ${props => props.theme.colors.negative};
        transition: border .2s ease;

        &:hover,
        &:focus-within {
            border-color: ${props => props.theme.colors.text};
        }

        ${Media.greaterThan('s')`
            font-size: 16px;
        `}
    }
`